

export class SorteoOportuno {
    folio: string;
    correo: string;
}